var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SearchObject', {
    ref: "search",
    staticClass: "mt-0",
    attrs: {
      "additional-params": Object.assign({
        ordering: '-invoice_date'
      }, _vm.additionalParams),
      "allow-create": _vm.allowCreate,
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "create-label": _vm.$translate('create_a_invoice'),
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_invoice'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "error-messages": _vm.errorMessages,
      "dense": _vm.dense,
      "flat": _vm.flat,
      "outlined": _vm.outlined,
      "background-color": _vm.backgroundColor,
      "icon": _vm.icon
    },
    on: {
      "create": _vm.createInvoice,
      "input": _vm.handleInput,
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.id == 'new' ? _c('div', {
          staticClass: "my-1"
        }, [_vm._v(" " + _vm._s(item.name) + " ")]) : _c('div', {
          staticClass: "my-1"
        }, [_c('div', {
          staticClass: "text-body-2"
        }, [_vm._v(" " + _vm._s(_vm.$moment(item.invoice_date).format('DD/MM/YYYY')) + " - " + _vm._s(_vm.$utils.getInvoiceIdText(item)) + " ")]), item.total_amount_excl_vat ? _c('div', {
          staticClass: "text-caption text--secondary"
        }, [_vm._v(" " + _vm._s(_vm.price(item.total_amount_excl_vat)) + " ")]) : _vm._e()])];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }